// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2924":"7a1f8635","3548":"7a1f8635","5062":"e5fc220a","5085":"7a1f8635","7844":"7a1f8635","7845":"7a1f8635","9002":"7a1f8635"}[chunkId] + ".chunk.css";
};